import { Body, Flex } from '@cognite/cogs.js-v10';
import styled from 'styled-components';

interface TemplateListItemProps {
  $isSelected: boolean;
}

export const TemplateList = styled.ul`
  list-style-type: none;
  padding: 0;
  margin: 0;
`;

export const TemplateListItem = styled.li<TemplateListItemProps>`
  padding: 16px;
  border-bottom: 1px solid ${({ theme }) => theme['border--muted']};
  cursor: pointer;
  height: 84px;
  word-break: break-word;
  &:nth-child(odd) {
    background-color: ${({ theme, $isSelected }) =>
      $isSelected
        ? theme['surface--interactive--toggled-default']
        : theme['surface--muted']};
  }
  &:nth-child(even) {
    background-color: ${({ theme, $isSelected }) =>
      $isSelected
        ? theme['surface--interactive--toggled-default']
        : theme['surface--medium']};
  }

  &:hover {
    background-color: ${({ theme, $isSelected }) =>
      $isSelected
        ? theme['surface--interactive--toggled-hover']
        : theme['surface--interactive--hover']};
  }
`;

export const TemplateListItemTitle = styled(Body).attrs({
  strong: true,
  level: 2,
})`
  margin-bottom: 8px;
  line-height: 21px;
  height: 42px;
  overflow: hidden;
`;

export const EmptyStateContainer = styled(Flex)`
  justify-content: center;
  margin: 16px;
`;
